import { Tag } from '@dev-spendesk/grapes';
import React from 'react';

interface Props {
  onToggleGringottsIframe: () => void;
}

export const GringottsProfileItem = ({ onToggleGringottsIframe }: Props) => {
  return (
    <button
      type="button"
      className="w-full cursor-pointer border-none bg-background-primary-default body-m hover:bg-background-primary-hover"
      onClick={onToggleGringottsIframe}
    >
      Gringotts
      <Tag className="ml-8" variant="purple">
        Demo and dev
      </Tag>
    </button>
  );
};
